import getCountryFromUrl from '@PayseraServiceAgreementBundle/Resources/assets/js/service/getCountryFromUrl';

import RecruitmentClient from './RecruitmentClient';
import { axiosInstance, axiosInterceptor } from '../../paysera-recaptcha-modal';

export default () => {
    const instance = axiosInstance();
    instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    instance.defaults.headers.common['X-Context-Country'] = getCountryFromUrl()?.toLowerCase() ?? 'lt';
    instance.defaults.maxRedirects = 0;
    instance.interceptors.response.use(
        response => response,
        async error => ((await axiosInterceptor)(error)),
    );

    return new RecruitmentClient(instance);
};
